import { getWorkloadScenarioType } from '../utils/getWorkloadScenarioType';
import { createUpdateScenarioSettingUrl } from '../utils/createUpdateScenarioSettingsUrl';
import { makePatchRequest } from 'owa-ows-gateway';
import {
    SelectedCalendarListViewRequestType,
    SelectedCalendarListViewType,
} from '../schema/ScenarioSettings/SelectedCalendarListView';
import { getOwaWorkload } from 'owa-workloads';
import { isSupportedWorkload } from '../utils/isSupportedWorkload';

export async function updateSelectedCalendarListViewService(
    selectedView: SelectedCalendarListViewType
): Promise<void> {
    const workload = getOwaWorkload();
    if (isSupportedWorkload(workload)) {
        const scenario = getWorkloadScenarioType(workload);
        const requestUrl = createUpdateScenarioSettingUrl(scenario, 'SelectedCalendarListView');
        const SelectedCalendarListView: SelectedCalendarListViewRequestType = {
            ViewType: selectedView,
        };
        await makePatchRequest(
            requestUrl,
            SelectedCalendarListView,
            undefined /* correlationId */,
            undefined /* returnFullResponse */,
            undefined /* customHeaders */,
            true /* throwServiceError */,
            undefined /* isThrottled */
        );
    }
}
